import { SubmissionMethod } from "generated-graphql/graphql";

/**
 * Type guard for narrowing a raw `string` (e.g. a MUI Select `onChange` value or
 * a URL search param) to a `SubmissionMethod` without an `as` cast. The value is
 * validated against the enum's own members.
 */
export function isSubmissionMethod(value: string): value is SubmissionMethod {
  return Object.values(SubmissionMethod).some((method) => method === value);
}
